export default [
	{
		key: 'name',
		title: 'Name',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'description',
		title: 'Description',
		scopedSlots: {customRender: 'description'}
	}, {
		dataIndex: 'updated_at',
		key: 'updatedAt',
		title: 'Last Updated',
		scopedSlots: {customRender: 'updatedAt'}
	}, {
		key: 'action',
		title: '',
		scopedSlots: {customRender: 'action'}
	}
]

